// extracted by mini-css-extract-plugin
export default {"infoAlert":"Login_infoAlert__O79D4","infoIcon":"Login_infoIcon__Za78s"};